/*!
  * devtools-if v9.2.0-beta.25
  * (c) 2021 kazuya kawaguchi
  * Released under the MIT License.
  */
const IntlifyDevToolsHooks =  {
    I18nInit: 'i18n:init',
    FunctionTranslate: 'function:translate'
};

export { IntlifyDevToolsHooks };
